$(document).on("click", ".card-header.toggle-card-body", function (e) {
  e.preventDefault()
  $(`#${$(this).data("target")}`).slideToggle()
})

$(document).on("click", "button.test-integration", function () {
  $(this).parent().find("button.save-integration").hide()
  $(this).parent().find("input[type=hidden].test-integration").val(1)
})

$(document).on("click", "button.save-integration", function () {
  $(this).parent().find("button.test-integration").hide()
})
